import { render, staticRenderFns } from "./BeneficioFiscalForm.vue?vue&type=template&id=567d2162&"
import script from "./BeneficioFiscalForm.vue?vue&type=script&lang=js&"
export * from "./BeneficioFiscalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports